import ChartColumnStacked from 'src/sections/charts/chart-column-stacked';
import { CHART_INNER_HEIGHT } from './constants';

interface FunnelConversionsChartProps {
  series: { name: string; data: number[] }[];
  labels: string[];
  showLabels?: boolean;
  /** Per-series fill colors, by series index. Falls back to the chart's default palette. */
  colors?: string[];
  /** Format values as currency (when the displayed metric is Revenue). */
  currency?: boolean;
}

export default function FunnelConversionsChart({
  series,
  labels,
  showLabels = false,
  colors,
  currency = false,
}: FunnelConversionsChartProps) {
  return (
    <ChartColumnStacked
      series={series}
      labels={labels}
      height={CHART_INNER_HEIGHT}
      colors={colors}
      barBorderRadius={4}
      showDataLabels={showLabels}
      legendMarkerSize={8}
      legendLabelColor="#637381"
      currency={currency}
    />
  );
}
